import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { MerchantChange } from '../../entities/merchant-change.model';

@Injectable()
export class WebBaseDataService {

  private _selectedMerchantChange: MerchantChange;

  constructor(private http: Http) { }


  get selectedMerchantChange(): MerchantChange {
    return this._selectedMerchantChange;
  }

  set selectedMerchantChange(value: MerchantChange) {
    this._selectedMerchantChange = value;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/web-base-data/web-base-data.service.ts